export default __webpack_public_path__ + "static/media/top-img.6ed41d51.png";